import React from 'react';

import { withPageAccess } from 'hocs/withPageAccess';
import { LogicShowKey } from 'stores/global/RootStore/AppConfigStore';
import { useAppConfig } from 'stores/global/RootStore/context';

export const withFeatureAccess = <P extends Record<string, unknown>>(
  Component: React.ComponentType<P>,
  feature: LogicShowKey,
  redirectTo?: string,
) =>
  withPageAccess(Component, {
    useAccess: () => useAppConfig().logic[feature].show,
    redirectTo,
  });
